// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import { BASE_URL } from '../../../../constants/app.constants'

export const getAllData = createAsyncThunk(
  'appUsers/getAllData',
  async ({ page, size, role, search }) => {
    const response = await axios.get(
      `${BASE_URL}/admin?${
        size === 0 ? '' : `limit=${size}&page=${page}${role ? `&${role}` : ''}`
      }${search ? `&${search}` : ''}`
    )
    return {
      data: response.data.data.map((currnt) => ({
        id: currnt.id,
        fullName: currnt.fullName,
        role: currnt.role,
        email: currnt.email,
        status: currnt.status,
        avatar: currnt?.profileimage || '/static/media/9.8617df44.png',
        staff: currnt?.staff
      })),
      totalPages: response.data.pageCount
    }
  }
)
export const getUsersCount = createAsyncThunk('appUsers/getUserCount', async () => {
  const response = await axios.get(`${BASE_URL}/admin/count`)
  return response.data
})
export const getUserRole = createAsyncThunk('appUsers/getUserRole', async () => {
  const response = await axios.get(`${BASE_URL}/admin/auth/roles-list`)
  return response.data
})

export const getData = createAsyncThunk('appUsers/getData', async (params) => {
  const response = await axios.get('/api/users/list/data', params)
  return {
    params,
    data: response.data.data.map((currnt) => ({
      id: currnt.id,
      fullName: currnt.fullName,
      role: currnt.role.toLowerCase(),
      email: currnt.email,
      status: 'active',
      avatar: currnt?.image || '',
      staff: currnt?.staff
    })),
    totalPages: 1
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async (id) => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch }) => {
  try {
    await axios.post(`${BASE_URL}/admin/auth/register`, user)
    // await dispatch(getData(getState().users.params))
    dispatch(getAllData({ size: 10, page: 1 }))
    return user
  } catch (error) {
    throw new Error(
      error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        'Internal error'
    )
  }
})
export const updateUser = createAsyncThunk('appUsers/updateUser', async (user, { dispatch }) => {
  try {
    await axios.patch(`${BASE_URL}/admin/update/${user.id}`, user.data)
    dispatch(getAllData({ size: 10, page: 1 }))
    return user
  } catch (error) {
    throw new Error(
      error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        'Internal error'
    )
  }
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch }) => {
  await axios.delete(`${BASE_URL}/admin/${id}`)
  // await dispatch(getData(getState().users.params))
  await dispatch(getAllData({ size: 10, page: 1 }))
  return id
})

export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    userRoles: [],
    roleCount: {
      Admin: 0,
      Hr: 0,
      SubAdmin: 0,
      Totals: 0
    },
    selectedUser: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload.data
        state.total = action.payload.totalPages
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
      .addCase(getUserRole.fulfilled, (state, action) => {
        state.userRoles = action.payload
      })
      .addCase(getUsersCount.fulfilled, (state, action) => {
        action.payload.forEach((element) => {
          if (element.role === 'HR Manager') {
            state.roleCount.Hr = element.count
          }
          if (element.role === 'Super Admin') {
            state.roleCount.Admin = element.count
          }
          if (element.role === 'Admin Manager') {
            state.roleCount.SubAdmin = element.count
          }
        })

        let total = 0

        for (const current of action.payload) {
          total += Number(current.count)
        }

        state.roleCount.Totals = total
      })
  }
})

export default appUsersSlice.reducer
